import { ToastStatus } from '../pages/interfaces/MatchUI';

const toastColorMap = new Map<ToastStatus, string>([
    ['success', '#d4edda'],
    ['failed', '#f8d7da'],
    ['warning', '#ffff00'],
    [null, 'transparent'],
]);

export { toastColorMap };
